// extracted by mini-css-extract-plugin
export default {"header":"ServiceElections_header__FP8Na","contentContainer":"ServiceElections_contentContainer__31cUN"};